import type { FC, ReactNode } from 'react'
import type { ProjectSummary } from '@/types'

import { Reveal } from '@/components/motion/reveal'
import { ArrowLink } from '@/components/site/arrow-link'
import { SectionHeading } from '@/components/site/section-heading'
import { WorkCard } from '@/components/site/work-card'

interface HomeWorkProps {
    projects: ProjectSummary[]
}

export const HomeWork: FC<HomeWorkProps> = ({ projects }): ReactNode => {
    return (
        <section
            id='work'
            className='relative z-[2] flex w-full flex-col items-start gap-6 overflow-clip bg-background px-4 pt-16 lg:flex-row lg:px-6 lg:pb-16'
        >
            <div className='relative z-[2] w-full lg:sticky lg:top-16 lg:max-w-[28%] lg:flex-1'>
                <SectionHeading lead="Selected" title="work" />
            </div>

            <div className='flex w-full flex-col items-center gap-16 lg:flex-1 lg:pt-section-lg'>
                {projects.length > 0 ? (
                    projects.map((project) => (
                        <Reveal key={project.id} className='w-full'>
                            <WorkCard project={project} />
                        </Reveal>
                    ))
                ) : (
                    <p className='t-italic py-10 text-muted-foreground'>
                        New projects are on the way.
                    </p>
                )}
            </div>

            <div className='relative z-[1] flex w-full justify-center py-10 lg:sticky lg:top-0 lg:h-screen lg:w-[277px] lg:max-w-[24%] lg:flex-none lg:items-end lg:justify-end'>
                <ArrowLink href='/work' label="View all projects" />
            </div>
        </section>
    )
}
